module.exports = __webpack_public_path__ + "static/img/lacobel-matelac-3.644b94e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/agc/items/lacobel-matelac/lacobel-matelac-3.jpg
// module id = 521
// module chunks = 0